import { usePlayer as usePlayerFree } from './usePlayer.free';
import { usePlayer as usePlayerSdk } from './usePlayer.sdk';

const SLDP_MODE = window.env.VITE_SLDP_MODE || 'free';

export const usePlayer = SLDP_MODE === 'sdk' ? usePlayerSdk : usePlayerFree;
